/** HoldingScreen (SCN-612) — branded placeholder when no playlist is assigned (204). */
export function HoldingScreen() {
  return (
    <div className="fullscreen holding">
      <div className="holding__logo">Scanify</div>
      <div className="holding__glyph">▶</div>
      <div className="holding__title">Coming soon</div>
      <p className="holding__sub">
        Check back later — your store admin is preparing the display content.
      </p>
    </div>
  );
}
